import Pagination from "../utils/Pagination";
import { Link } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../redux/actions/ModalActions";

export default function Tasks({
  tasks,
  totalData,
  currentPage,
  itemsPerPage,
  handlePageChange,
  handleItemsPerPageChange,
  batchId,
}) {
  const userRole = sessionStorage.getItem("userRole");
  const [type, setType] = useState("");
  const [status, setStatus] = useState(true);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);

  const handleStatusChange = (event) => {
    setStatus(JSON.parse(event.target.value)); // Ensure the value is parsed as boolean
  };

    const addBackTask = (id, taskStatus) => {
    let data = {
      _id: id,
      status: !taskStatus,
    };
    dispatch(
      showModal("StatusModal", data, "changeStatusAssignTask", "addBackTask")
    );
  };

    const removeTask = (id, taskStatus) => {
    let data = {
      _id: id,
      status: !taskStatus,
    };
    dispatch(
      showModal("StatusModal", data, "changeStatusAssignTask", "remove")
    );
  };

  const filteredTasks = tasks?.filter((task) => {
  // filter by status
  if (task.status !== status) return false;

  // optional: filter by type (Assignments / Tests)
  if (type && Number(task.taskType) !== Number(type)) return false;

  return true;
});

  

  return (
    <>
    {console.log("Task data",tasks)
    }
      <div className="container">
        <div className="align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
          <div className="d-flex justify-content-between ">
            <select
              className="form-select me-2 w-25"
              onChange={(e) => {
                setType(e.target.value);
              }}
              value={type}
            >
              <option value={""}>All</option>
              <option value={1}>Assignments</option>
              <option value={2}>Tests</option>
            </select>
            <div className="w-75 d-flex justify-content-end">
              <select
                className="form-select me-2 w-25"
                onChange={handleStatusChange}
                value={status}
              >
                <option value={true}>Current</option>
                <option value={false}>Removed</option>
              </select>
              <button
                onClick={() => {
                  dispatch(showModal("AssignTask"));
                }}
                className="btn btn-primary btn-round"
              >
                Assign Task
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          {filteredTasks?.length > 0 ? (
            filteredTasks?.map((task, index) => (
              <div className="col-sm-12 text-capitalize" key={index}>
                <Link
                  to={
                    userRole == 1
                      ? `/admin/marks/${batchId}/${task?._id}`
                      : `/trainer/marks/${batchId}/${task?._id}`
                  }
                  state={{ batchId, taskId: task?._id }}
                  className="text-dark fw-bold text-decoration-none"
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <div>{task?.name}</div>
                      <span className="text-muted">
                        MM :{task?.maximumMarks}
                      </span>
                      <br />

                      {/* Show trainer name directly from task.trainerId */}
                      {task?.trainerId?.name && (
                        <span className="text-info">
                          Posted By: {task.trainerId.name}
                        </span>
                      )}
                      <br />
                    </div>
                    <div>
                      <div className="d-flex">
                        <span className="mt-2 text-muted">
                          Due : {task?.date}
                        </span>
                        <div className="dropdown">
                          <IconButton
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <ul className="dropdown-menu">
                            {status ? (
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removeTask(task?._id, task?.status);
                                  }}
                                >
                                  Remove
                                </a>
                              </li>
                            ) : (
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    addBackTask(task?._id, task?.status);
                                  }}
                                >
                                  Add Back
                                </a>
                              </li>
                            )}
                            <li>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  dispatch(
                                    showModal("EditTask", {
                                      _id: task?._id,
                                    })
                                  );
                                }}
                                className="dropdown-item"
                                href="#"
                              >
                                Edit
                              </a>
                            </li>
                            <li>
                              <Link
                                to={`/trainer/marks/${batchId}/${task?._id}`}
                                className="dropdown-item"
                              >
                                View
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`/trainer/submission/${batchId}/${task?._id}`}
                                className="dropdown-item"
                              >
                                View Submissions
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <span className="text-success">Assigned:</span>{" "}
                        {task?.totalAssigned},
                        <span className="text-danger">Not Assigned:</span>{" "}
                        {task?.totalNotAssigned}
                      </div>
                    </div>
                  </div>
                </Link>
                <hr className="my-1" />
              </div>
            ))
          ) : (
            <h1>No Task Present!!</h1>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <Pagination
            count={totalData}
            page={currentPage}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      </div>
    </>
  );
}
